import { useContext } from 'react'
import styled from 'styled-components'
import Button from '../../../components/Buttons/Button'
import ModalContext from '../../../context/ModalContext'

const Wrapper = styled.div`
  width: 320px;
`

const Text = styled.div`
  font-size: 18px;
  color: var(--text-color);
  margin-bottom: 16px;
`

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`

export default function ConfirmationWindow({
  text = 'Удалить маршрут?',
  confirmLabel = 'Удалить',
  cancelLabel = 'Отмена',
  onConfirm
}) {
  const { closeModal } = useContext(ModalContext)

  const handleConfirm = () => {
    onConfirm?.()
    closeModal()
  }

  return (
    <Wrapper>
      <Text>{text}</Text>

      <ButtonsWrapper>
        <Button
          style={{
            color: 'var(--cancel-button-text)',
            backgroundColor: 'var(--cancel-button-bg)',
            border: 'var(--cancel-button-border)',
            minWidth: '140px',
          }}
          onClick={closeModal}
          waves={false}
        >
          {cancelLabel}
        </Button>

        <Button
          style={{
            minWidth: '140px',
            backgroundColor: 'var(--alert-button-bg)',
          }}
          onClick={handleConfirm}
        >
          {confirmLabel}
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  )
}
